import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ProtocoloForm from './ProtocoloForm';
import protocoloService from '../../services/protocoloService';

/**
 * Registro manual de protocolo. Existe porque há requerentes que não estão
 * no cadastro — nesse caso o pedido não gera o protocolo sozinho.
 */
const ProtocoloCreate = () => {
  const navigate = useNavigate();

  const salvar = async (dados) => {
    const resposta = await protocoloService.create(dados);
    toast.success(resposta.message || 'Protocolo registrado com sucesso.');
    navigate('/protocolos');
  };

  return <ProtocoloForm titulo="Registrar protocolo de requerimento" onSalvar={salvar} />;
};

export default ProtocoloCreate;
